var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5251 32.5569L34.0251 32.5569L34.0251 32.0569L34.0251 5.31763C34.0251 2.83235 32.0104 0.817628 29.5251 0.817628L9.15039 0.817627C6.66511 0.817627 4.65039 2.83235 4.65039 5.31763L4.65039 32.0569L4.65039 32.5569L5.15039 32.5569L33.5251 32.5569Z",
    fill: "#FFBC58",
    stroke: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46045 20.9201C2.46045 19.2168 3.8413 17.8359 5.54466 17.8359C7.24802 17.8359 8.62887 19.2168 8.62887 20.9201L8.62887 36.5468L6.46045 36.5468C4.25131 36.5468 2.46045 34.7559 2.46045 32.5468L2.46045 20.9201Z",
    fill: "#FFBC58",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5312 19.4956C31.5312 17.7922 32.9121 16.4114 34.6155 16.4114C36.3188 16.4114 37.6997 17.7922 37.6997 19.4956L37.6997 31.1222C37.6997 33.3314 35.9088 35.1222 33.6997 35.1222L31.5312 35.1222L31.5312 19.4956Z",
    fill: "#FFBC58",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4595 31.0939L38.4595 35.3801C38.4595 37.5893 36.6686 39.3801 34.4595 39.3801L6.00001 39.3801C3.79087 39.3801 2.00001 37.5893 2.00001 35.3801L2.00001 31.0939L38.4595 31.0939Z",
    fill: "#FFBC58",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/front.2caad58ce4762e7f78f5c2a465218b01.svg";
export { ForwardRef as ReactComponent };